import PromoCode from './ReferenceNumber';

export default PromoCode;
